<script>
    export default {
        data () {
            return {
                drawer: false
            }
        }
    }
</script>

<template>
    <div class="">
        <el-button
            @click="drawer = true"
            size="mini"
            type="primary"
            plain>
            Get widget
        </el-button>

        <el-drawer
            title="EMBED EMALIFY CHAT WIDGET IN YOUR SITE"
            :visible.sync="drawer"
            size="60%">

            <div class="drawer-area">
                <div class="drawer-body">
                    <div class="row lite-form">
                        <div class="col-md-12">
                            <div class="text-header">
                                <p>To get the widget to your web application:</p>
                            </div>

                            <div class="text-list">
                                <p>Copy the code below and add it below the body tags of your index website page.</p>
                            </div>

                            <br>

                            <pre class="pretty-print">
      &lt;<span class="pl-ent">emalify-chat-widget<span></span></span>&gt;&lt;/<span class="pl-ent">emalify-chat-widget</span>&gt;
      &lt;<span class="pl-ent">script</span>  <span class="pl-e">src</span>=<span class="pl-s"><span class="pl-pds">"</span>https://emalify-chat-dot-chatleo-111.appspot.com/js/main.js<span class="pl-pds">"</span></span>&gt;&lt;/<span class="pl-ent">script</span>&gt;
                      </pre>

                            <br>
                            <br>
                        </div>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>


<style>
    .pretty-print {
        background-color: #f8f8f8;
        padding-top: 20px;
        font-size: 14px;
        font-weight: bolder;
        color: #7d7777;
    }

    .text-header {
        font-size: 16px;
        font-weight: bolder;
    }

    .text-list {
        font-size: 16px;
        font-family: Roboto, sans-serif;
    }
</style>
